<template>
  <div class="step-one-container">
    <div class="show-content">
      <div>
        <div class="content">
          <h3>{{ content.title }}</h3>
          <p>{{ content.subtitle }}</p>
        </div>
        <div class="feature-wrapper">
          <div
              v-for="feature in content.features"
              :key="feature.text"
              :class="['feature-item', feature.type]">
            <div class="icon-wrapper">
              <img :src="require(`@/assets/tutorials/${feature.icon}.png`)" alt="" />
            </div>
            <span>{{ feature.text }}</span>
          </div>
        </div>
        <div class="btn-wrapper">
          <el-button type="text" class="btn-text" @click="handleSkipTutor">{{ $t('Tutorials.Step1.btn2') }}</el-button>
          <el-button type="primary" class="btn-start" @click="handleStart">{{ $t('Tutorials.Step1.btn1') }}</el-button>
          <el-button type="text" class="btn-text quick-start" @click="handleNext">{{ $t('Tutorials.Step1.btn3') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { simonTransferTypes, getSimonTransferObj} from "@/utils/simonTransfer";

export default {
  name: "stepOne",
  computed: {
    lang() {
      return this.$store.getters.lang;
    },
    content() {
      if(this.lang === 'zh-CN') {
        return {
          title: 'Simon AI 全新上线',
          subtitle: '你的单细胞分析AI助手',

          features: [{
            type: 'analysis',
            icon: 'interpreter',
            text: '解读分析结果',
          },{
            type: 'chart',
            icon: 'plotter',
            text: '生成可视化图表',
          },{
            type: 'cloud',
            icon: 'explorer',
            text: '提交云端分析',
          }],
        };
      }
      return {
        title: 'Simon AI is Here',
        subtitle: 'Your single-cell analysis AI assistant',
        features: [{
          type: 'analysis',
          icon: 'interpreter',
          text: 'Interpret analysis results',
        },{
          type: 'chart',
          icon: 'plotter',
          text: 'Generate visualizations',
        },{
          type: 'cloud',
          icon: 'explorer',
          text: 'Submit cloud analysis',
        }],
      };
    },
  },
  methods: {
    // 跳过教程
    handleSkipTutor() {
      this.$emit('closeDialog');
    },
    handleStart() {
      getSimonTransferObj(simonTransferTypes.topNav);
    },
    //  下一步
    handleNext() {
      this.$emit('sendNextStep', 'two');
    },
  },
};
</script>

<style scoped lang="scss">
.step-one-container {
  padding: 10px;
  background: linear-gradient( 180deg, #E6F2FF 0%, #FFFFFF 100%);
  .show-content {
    border-radius: 8px;
    border: 1px solid rgba(151,151,151,0.26);
    padding: 22px 18px 14px 18px;
    .content {
      text-align: center;
      h3 {
        font-weight: bold;
        font-size: 20px;
        color: #000000;
        line-height: 24px;
      }
      p {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        margin-top: 6px;
        line-height: 18px;
      }
    }
    .feature-wrapper {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin: 30px 6px;
      .feature-item {
        width: 33.33%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        color: #202020;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        white-space: nowrap;
        .icon-wrapper {
          width: 34px;
          height: 34px;
          margin-bottom: 10px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .btn-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 40px;
      .btn-text {
        min-width: 88px;
        padding: 0;
        color: #8F8F8F;
        text-align: left;
      }
      .quick-start {
        color: #0D65BD;
        text-align: right;
      }
      .btn-start {
        width: 160px;
        height: 40px;
        background: #0D65BD;
        border-color: #0D65BD;
        border-radius: 20px;
        font-weight: bold;
      }
    }
    .cn-wrapper {
      .content {
        text-align: left;
        padding-left: 4px;
      }
      .feature-wrapper {
        flex-direction: column;
        align-items: flex-start;
        margin: 18px 4px 18px;
        .feature-item {
          width: 100%;
          flex-direction: row;
          justify-content: flex-start;
          margin-top: 4px;
          line-height: 20px;
          .icon-wrapper {
            display: none;
          }
        }
      }
    }
  }
}
</style>